/**
 * Programmatically re-select an object in the PlayCanvas scene by id (entity name).
 * This triggers the same selection flow as a user click, restoring the outline.
 */
export async function selectObjectById(id: string | number) {
  try {
    // @ts-ignore
    const containerRef = window.containerRef;
    const win: any = containerRef?.current?.contentWindow;
    if (!win || !win.RoutingScriptMdel) return;

    const root = win.RoutingScriptMdel.getRootEntity?.();
    const sceneController = root?.script?.sceneController;
    const parent = sceneController?.objectParent;
    const target = parent?.findByName?.(String(id));

    if (!target) return;

    if (sceneController?.onSelectionChanged) {
      // Call the same handler Raycast/assetloader uses so outline logic runs
      sceneController.onSelectionChanged(target);
    } else if (root?.app?.fire) {
      // Fallback: emit the outline event directly
      root.app.fire("Ermis:objectOutline:add", target);
      // Attempt to toggle bbox if script is present
      try {
        target?.script?.bbox?.setup?.();
        if (target?.script?.bbox) target.script.bbox.showBounds = true;
        win.itemSelected = true;
      } catch {}
    }
  } catch (e) {
    // silent fail – selection restore is best-effort
    console.warn('selectObjectById failed', e);
  }
}
